module.exports = __webpack_public_path__ + "img/skull_19_bj.b9c20cc5.png";